<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">Mountain People</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#location-maps">Location Maps</a></li>
<li id="toc-li-6"><a href="#/text/ch006#part-1-mountain-people">Part 1: Mountain People</a>
<ol>
<li id="toc-li-8"><a href="#/text/ch008#a-special-kind-of-witness">1. A Special Kind of Witness</a></li>
</ol>
</li>
<li id="toc-li-9"><a href="#/text/ch010#part-2-witnesses">Part 2: Witnesses</a>
<ol>
<li id="toc-li-10"><a href="#/text/ch010#section-1"></a></li><a href="#/text/ch010#section-1">
</a><li id="toc-li-11"><a href="#/text/ch010#section-1"></a><a href="#/text/ch011#past-present-and-future-intertwined">2. Past, Present and Future
                Intertwined</a></li>
<li id="toc-li-12"><span href="#/text/ch012#josep-and-maría-and-family" title="Link target outside of Sample">3. Josep and María and Family</span></li>
<li id="toc-li-13"><span href="#/text/ch013#itchy-feet" title="Link target outside of Sample">4. Itchy Feet</span></li>
<li id="toc-li-14"><span href="#/text/ch014#a-rising-star" title="Link target outside of Sample">5. A Rising Star?</span></li>
<li id="toc-li-15"><span href="#/text/ch015#your-place-or-mine" title="Link target outside of Sample">6. Your Place or Mine?</span></li>
<li id="toc-li-16"><span href="#/text/ch016#a-landing-stage-at-the-end-of-the-rapids" title="Link target outside of Sample">7. A Landing Stage at the
                End of the Rapids</span></li>
<li id="toc-li-17"><span href="#/text/ch017#magnetic-mountains" title="Link target outside of Sample">8. Magnetic Mountains</span></li>
<li id="toc-li-18"><span href="#/text/ch018#lost-in-space" title="Link target outside of Sample">9. Lost in Space</span></li>
<li id="toc-li-19"><span href="#/text/ch019#settled" title="Link target outside of Sample">10. Settled</span></li>
<li id="toc-li-20"><span href="#/text/ch020#foreigners" title="Link target outside of Sample">11. Foreigners?</span></li>
<li id="toc-li-21"><span href="#/text/ch021#reintroduction" title="Link target outside of Sample">12. Reintroduction</span></li>
</ol>
</li>
<li id="toc-li-22"><span href="#/text/ch022#part-3-fate-hope-and-refusal" title="Link target outside of Sample">Part 3: Fate, Hope and Refusal</span>
<ol>
<li id="toc-li-23"><span href="#/text/ch023#background" title="Link target outside of Sample">13. Background</span></li>
<li id="toc-li-24"><span href="#/text/ch024#fate" title="Link target outside of Sample">14. Fate</span>
<ol class="toc">
<li id="toc-li-25"><span href="#/text/ch024#fate-mobility-and-change" title="Link target outside of Sample">Fate, mobility and change</span>
</li>
<li id="toc-li-26"><span href="#/text/ch024#fate-depopulation-and-vanishing-ways-of-life" title="Link target outside of Sample">Fate,
                        depopulation and vanishing ways of life</span></li>
<li id="toc-li-27"><span href="#/text/ch024#fate-exodus-of-the-young-and-who-wants-to-live-here-anyway" title="Link target outside of Sample">Fate, exodus
                        of the young and who wants to live here anyway?</span></li>
<li id="toc-li-28"><span href="#/text/ch024#fate-and-incomers" title="Link target outside of Sample">Fate and incomers</span></li>
<li id="toc-li-29"><span href="#/text/ch024#fate-and-disunity-among-incomers-and-natives" title="Link target outside of Sample">Fate and
                        disunity among incomers and ‘natives’</span></li>
<li id="toc-li-30"><span href="#/text/ch024#fate-and-local-impacts-of-wider-processes" title="Link target outside of Sample">Fate and local
                        impacts of wider processes</span></li>
<li id="toc-li-31"><span href="#/text/ch024#fatalism" title="Link target outside of Sample">Fatalism?</span></li>
</ol>
</li>
<li id="toc-li-32"><span href="#/text/ch025#hope" title="Link target outside of Sample">15. Hope</span>
<ol class="toc">
<li id="toc-li-33"><span href="#/text/ch025#hope-through-accommodating-the-local-within-a-wider-sense-of-place" title="Link target outside of Sample">Hope
                        through accommodating the local within a wider sense of place</span></li>
<li id="toc-li-34"><span href="#/text/ch025#hope-through-incomers-who-buy-into-the-local" title="Link target outside of Sample">Hope through
                        incomers who buy into the local</span></li>
<li id="toc-li-35"><span href="#/text/ch025#in-ariège" title="Link target outside of Sample">In Ariège</span></li>
<li id="toc-li-36"><span href="#/text/ch025#in-the-cardós-valley" title="Link target outside of Sample">In the Cardós Valley</span></li>
<li id="toc-li-37"><span href="#/text/ch025#hope-through-openness-and-respect-for-others" title="Link target outside of Sample">Hope through
                        openness and respect for others</span></li>
<li id="toc-li-38"><span href="#/text/ch025#hope-through-creative-bricolage" title="Link target outside of Sample">Hope through creative
                        <em>bricolage</em></span></li>
<li id="toc-li-39"><span href="#/text/ch025#active-hope-through-working-to-fulfil-visions" title="Link target outside of Sample">Active hope
                        through working to fulfil visions</span></li>
</ol>
</li>
<li id="toc-li-40"><span href="#/text/ch026#conclusion-hope-fate-and-refusal" title="Link target outside of Sample">16 .Conclusion: Hope, Fate and
                Refusal</span></li>
</ol>
</li>
<li id="toc-li-41"><span href="#/text/ch027#postscript" title="Link target outside of Sample">Postscript</span></li>
<li id="toc-li-42"><span href="#/text/ch028#bibliography" title="Link target outside of Sample">Bibliography</span></li>
<li id="toc-li-43"><span href="#/text/ch029#more-from-the-authors" title="Link target outside of Sample">More from the Authors</span></li>
<li id="toc-li-44"><span href="#/text/ch030#endnote" title="Link target outside of Sample">Endnote</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?b8d1eda8